import axios from 'axios';

export default axios.create({
  baseURL: `/api/`,
  headers: { Authorization : localStorage.getItem(`jwt`) },
});



// WEBPACK FOOTER //
// ./src/api.js